import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { apiClient } from "../../lib/api";
import { artworkId } from "../../lib/ids";
import { formatPrice } from "../../lib/format";

const statusStyles: Record<string, string> = {
  available: "text-[var(--color-kj-accent)]",
  sold: "text-[var(--color-kj-text-light)]",
  archived: "text-[var(--color-kj-text-light)] italic",
};

const AdminDashboardPage = () => {
  const query = useQuery({
    queryKey: ["admin-artworks"],
    queryFn: () => apiClient.frontend.AdminListArtworks(),
  });

  const artworks = query.data?.Artworks ?? [];

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <h1 className="font-display text-3xl uppercase-track">Artwork</h1>
          <p className="text-xs uppercase-track text-[var(--color-kj-text-light)] mt-1">
            {artworks.length} {artworks.length === 1 ? "piece" : "pieces"}
          </p>
        </div>
        <Link
          to="/admin/artwork/new"
          className="font-display uppercase-track text-xs px-6 py-2.5 border border-[var(--color-kj-text)] hover:bg-[var(--color-kj-text)] hover:text-[var(--color-kj-bg)] transition-colors"
        >
          + New artwork
        </Link>
      </div>

      {query.isLoading && (
        <p className="text-sm text-[var(--color-kj-text-light)]">Loading…</p>
      )}
      {query.isError && (
        <p className="text-sm text-[var(--color-kj-danger)]">Failed to load artwork.</p>
      )}

      {artworks.length === 0 && query.isSuccess && (
        <div className="text-center py-24 border border-dashed border-[var(--color-kj-border)]">
          <p className="font-display italic text-[var(--color-kj-text-light)] mb-4">
            No artwork yet.
          </p>
          <Link
            to="/admin/artwork/new"
            className="font-display uppercase-track text-xs border-b border-[var(--color-kj-border)] hover:border-[var(--color-kj-text)]"
          >
            Add your first piece
          </Link>
        </div>
      )}

      {artworks.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {artworks.map((a) => {
            const cover = a.Images[0];
            return (
              <Link
                to={`/admin/artwork/${artworkId(a.ID)}`}
                key={artworkId(a.ID)}
                className="block border border-[var(--color-kj-border)] hover:border-[var(--color-kj-text)] transition-colors"
              >
                <div className="aspect-[4/5] bg-[var(--color-kj-placeholder)]">
                  {cover ? (
                    <img
                      src={cover.URL}
                      alt=""
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-xs uppercase-track text-[var(--color-kj-text-light)]">
                      No images
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <p className="font-display text-lg">{a.Title}</p>
                  <p className="text-xs text-[var(--color-kj-text-light)]">
                    {formatPrice(a.PriceCents)}
                  </p>
                  <p className={`mt-1 text-[10px] uppercase-track ${statusStyles[a.Status] ?? ""}`}>
                    {a.Status}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminDashboardPage;
